import { FormHelperText } from "@mui/material";
import { FC } from "react";

const OptionalFieldHelperText: FC = () => {
  return (
    <FormHelperText>
      Campo opcional
    </FormHelperText>
  )
}

export default OptionalFieldHelperText;
